import Clarity from '@microsoft/clarity';
import { useEffect } from 'react';

/**
 * Initializes Microsoft Clarity once on the client when CLARITY_PROJECT_ID is set.
 * Project ID comes from next.config `env` / `publicEnv`.
 */
export const useMicrosoftClarity = (): void => {
  useEffect(() => {
    const projectId = process.env.CLARITY_PROJECT_ID;
    if (!projectId) {
      return;
    }

    Clarity.init(projectId);
  }, []);
};
